import { motion } from "framer-motion";

export const WhoWeWorkWith = () => {
  return (
    <section
      data-testid="who-section"
      className="py-24 md:py-36"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
        {/* Section label */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-sm tracking-[0.2em] uppercase mb-4"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 500,
            color: "var(--gold-dark)",
          }}
        >
          Clientele
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="text-3xl md:text-4xl lg:text-5xl tracking-tight mb-8"
          style={{
            fontFamily: "var(--font-serif)",
            fontWeight: 400,
            color: "var(--text-primary)",
          }}
        >
          A Selective Practice
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="text-base leading-relaxed mb-12"
          style={{
            fontFamily: "var(--font-sans)",
            fontWeight: 300,
            color: "rgba(26, 26, 26, 0.8)",
            lineHeight: 1.8,
          }}
        >
          Valtor Capital works with a carefully chosen group of high-net-worth
          individuals, family offices, private developers, and institutional
          partners. We do not take on every mandate — we take on the right ones.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="flex flex-wrap justify-center gap-4"
        >
          <span
            className="badge-elegant"
            data-testid="badge-investors"
          >
            Sophisticated Investors
          </span>
          <span
            className="badge-elegant"
            data-testid="badge-developers"
          >
            Private Developers
          </span>
        </motion.div>
      </div>
    </section>
  );
};
